
























import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ResultListItemr extends Vue {
    @Prop() place!: any;

    get displayPlaceName(): string {
      return this.place.name.toUpperCase();
    }

    get placeAddress(): string {
      if (this.place.noStreetAddress) {
        return `${this.place.city.name}`
      } else {
        return `${this.place.address}, ${this.place.city.name}`
      }
    }

    get placeDescription(): string {
      return this.place.company.description;
    }

    placeOnClick (): void {
        console.log(`Comp: User clicked on ${this.place.name}`)
        this.$emit('place-on-click', this.place)
    }

    get logoLetter() {
        return this.place.name[0];
    }
}
